import axiosWithAuth from './AxiosHelper';

// The message to show a user for a failed API call. Messages the backend
// wrote for users (validation errors, and its generic server-error text,
// which carries the reference to quote to the Exaloan team) are shown as
// they are; anything else - axios's own "Request failed with status code
// 500", raw error objects - becomes a plain sentence.
const GENERIC = 'Something went wrong. Please try again, or contact the Exaloan team.';
const UNREACHABLE = 'Could not reach Exaport. Please check your connection and try again.';

export const errorMessage = (err, fallback = GENERIC) => {
    if (err && !err.response && (err.request || err.message === 'Network Error')) return UNREACHABLE;
    const data = err?.response?.data;
    if (data && typeof data === 'object') {
        const message = data.error_msg || data.msg || data.error || data.detail || data.message;
        if (typeof message === 'string' && message.trim()) return message;
        if (Array.isArray(message) && message.length) return message.join(' ');
    }
    return fallback;
};

// Like errorMessage, but for any failure, including ones that happen in the
// browser itself (which the backend never sees): those are recorded in the
// backend's error_log, and the message carries the reference to quote.
// API failures are already recorded by the backend, so they aren't re-sent.
export const describeError = async (err, context) => {
    if (err?.response || err?.request) return errorMessage(err);
    try {
        const res = await axiosWithAuth.post('/client-errors', {
            context,
            message: err?.message || String(err),
            stack: err?.stack,
            page: window.location.pathname,
        });
        if (res.data?.reference) return `${GENERIC} (Reference: ${res.data.reference})`;
    } catch {
        // Recording failed too; still show the plain message.
    }
    return GENERIC;
};

export default errorMessage;
